/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Mijn PiE BFF
 * OpenAPI spec version: 1.0
 */

export type Answer = typeof Answer[keyof typeof Answer];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Answer = {
  Yes: 'Yes',
  No: 'No',
  DontKnow: 'DontKnow',
} as const;
